<template>
  <!-- <div class="addresses-list__divider"></div> -->
  <div class="addresses-list__item card address-card">
    <div class="address-card__badge tag-badge tag-badge--theme">{{ addressdata.type }}</div>
    <div class="address-card__body">
      <div class="address-card__name">{{ addressdata.name }}</div>
      <div class="address-card__row">
        {{ addressdata.company }}<br />
        {{ addressdata.address1 }}<br />
        <span v-if="addressdata.address2 != ''">{{ addressdata.address2 }}<br /></span>
        {{ addressdata.city }}, {{ addressdata.state }} {{ addressdata.zip }}
      </div>
      <div class="address-card__row">
        <div class="address-card__row-title">Phone Number</div>
        <div class="address-card__row-content">{{ format_phone_no(addressdata.phone) }}</div>
      </div>
      <div class="address-card__row">
        <div class="address-card__row-title">Email Address</div>
        <div class="address-card__row-content">{{ addressdata.email }}</div>
      </div>
      <div class="address-card__row">
        <div class="address-card__row-title">Account Number</div>
        <div class="address-card__row-content">{{ $store.getters.customer }}</div>
      </div>
      <div class="address-card__footer" v-if="addressdata.type != 'billing'">
        <router-link :to="'/account-edit/' + addressdata.type" class="mr-4">Edit</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router';
import Formatter from '../../../mixins/formatter';

export default {
    mixins: [Formatter],
    props: {
        index: {
            type: Number,
            required: true
        },
        addressdata: {
            type: Object,
            required: true
        }
    },
    methods: {
        removeAddress() {
            this.$emit("remove-address", this.index);
        }
    },
    components: { RouterLink }
}
</script>

<style scoped>
  .addresses-list__item {
    margin-left: 16px;
  }

  @media screen and  (max-width: 479px){
    .addresses-list__item {
      margin-left: 0;
    }
  }

  
</style>